import React from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

interface PromptEditorProps {
  prompt: string;
  agentId: number;
  onPromptChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const PromptEditor = ({ prompt, agentId, onPromptChange }: PromptEditorProps) => {
  const { toast } = useToast();

  const handleSavePrompt = async () => {
    try {
      const { error } = await supabase
        .from('ai_agents')
        .update({ prompt })
        .eq('id', agentId);

      if (error) throw error;

      toast({
        title: "Sucesso",
        description: "Prompt geral atualizado com sucesso!",
      });
    } catch (error) {
      console.error('Erro ao salvar prompt geral:', error);
      toast({
        title: "Erro",
        description: "Erro ao salvar o prompt geral",
        variant: "destructive",
      });
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Prompt Geral</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Textarea
          value={prompt}
          onChange={onPromptChange}
          className="min-h-[200px] resize-y"
          placeholder="Digite o prompt geral do agente..."
        />
        <Button onClick={handleSavePrompt} className="w-full">
          Salvar Prompt
        </Button>
      </CardContent>
    </Card>
  );
};